<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  mounted() {
    document.querySelector("#loadingMask").style.display = "none";
  },
};
</script>

<style lang="scss">
html,
body {
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  background: $htmlBackgroundColor;
}

#app {
  @include wh(750, 0);
  min-height: 100vh;
  height: auto;
  background: url("assets/images/home_bg.png") center no-repeat;
  background-size: 100% 100%;
  margin: auto;
  // position: absolute;;
  // left: 0;
  // right: 0;
}
</style>
